/**
 * Modal Context and Provider
 * ======================================
 * Created for reusing a single modal
 * component while using authentication
 * states to control the forms in modal.
 * ======================================
 */

import { useDisclosure } from "@chakra-ui/react";
import React, { useCallback, useState } from "react";
import HJSModal from "../components/base/molecules/HJSModal";
import { ModalTypes } from "../config/types/modals";
import useAuth from "../hooks/useAuth";

export interface IModalContext {
  onOpen: () => void;
  changeModalType: (modalType: ModalTypes) => void;
  modalType: string | undefined;
}

/* DEFAULT CONTEXT VALUES */
const ModalContextDefaults = {
  onOpen: () => undefined,
  changeModalType: (modalType: ModalTypes) => undefined,
  modalType: undefined,
};

/* CONTEXT DECLARATION */
export const ModalContext =
  React.createContext<IModalContext>(ModalContextDefaults);

/* MODAL CONTEXT PROVIDER */
export const ModalProvider: ({
  children,
}: {
  children: React.ReactNode;
}) => JSX.Element = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, userDetails } = useAuth();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [modalType, setModalType] = useState<ModalTypes>(() =>
    isAuthenticated ? ModalTypes.USER_PROFILE : ModalTypes.LOGIN
  );

  /**
   * Used for dynamically changing the form in the modal.
   * @function changeModalType
   * @param modalType - modalType enum value
   */
  const changeModalType = useCallback(
    (modalType: ModalTypes) => setModalType(modalType),
    []
  );

  // useEffect(() => {
  //   /**
  //    * * If else condition that checks if the user is authenticated
  //    * * and sets the respective modal form.
  //    */

  //   if (isAuthenticated && Boolean(userDetails?.name)) {

  //     changeModalType(ModalTypes.USER_PROFILE);
  //   } else {
  //     changeModalType(ModalTypes.LOGIN);
  //   }
  // }, [isAuthenticated, changeModalType]);

  return (
    <ModalContext.Provider
      value={{
        onOpen,
        changeModalType,
        modalType,
      }}
    >
      <HJSModal
        isOpen={isOpen}
        changeModalType={changeModalType}
        modalType={modalType}
        onClose={onClose}
      />
      {children}
    </ModalContext.Provider>
  );
};
